import React from 'react';
import { Divider } from '@mui/material';

import './_separator.scss';

const Separator = () => (
  <Divider className="separator" />
);

export default Separator;
